"use strict";

var _regeneratorRuntime = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/jenkins/tim-merchan/packages/site-merchan/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadableWebToNodeStream = void 0;

var readable_stream_1 = require("readable-stream");
/**
 * Converts a Web-API stream into Node stream.Readable class
 * Node stream readable: https://nodejs.org/api/stream.html#stream_readable_streams
 * Web API readable-stream: https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
 * Node readable stream: https://nodejs.org/api/stream.html#stream_readable_streams
 */


var ReadableWebToNodeStream = /*#__PURE__*/function (_readable_stream_1$Re) {
  _inherits(ReadableWebToNodeStream, _readable_stream_1$Re);

  var _super = _createSuper(ReadableWebToNodeStream);

  /**
   *
   * @param stream Readable​Stream: https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
   */
  function ReadableWebToNodeStream(stream) {
    var _this;

    _classCallCheck(this, ReadableWebToNodeStream);

    _this = _super.call(this);
    _this.bytesRead = 0;
    _this.released = false;
    _this.reader = stream.getReader();
    return _this;
  }
  /**
   * Implementation of readable._read(size).
   * When readable._read() is called, if data is available from the resource,
   * the implementation should begin pushing that data into the read queue
   * https://nodejs.org/api/stream.html#stream_readable_read_size_1
   */


  _createClass(ReadableWebToNodeStream, [{
    key: "_read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.released) {
                  _context.next = 3;
                  break;
                }

                this.push(null); // Signal EOF

                return _context.abrupt("return");

              case 3:
                this.pendingRead = this.reader.read();
                _context.next = 6;
                return this.pendingRead;

              case 6:
                data = _context.sent;
                // clear the promise before pushing pushing new data to the queue and allow sequential calls to _read()
                delete this.pendingRead;

                if (data.done || this.released) {
                  this.push(null); // Signal EOF
                } else {
                  this.bytesRead += data.value.length;
                  this.push(data.value); // Push new data to the queue
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _read() {
        return _read2.apply(this, arguments);
      }

      return _read;
    }()
    /**
     * If there is no unresolved read call to Web-API Readable​Stream immediately returns;
     * otherwise will wait until the read is resolved.
     */

  }, {
    key: "waitForReadToComplete",
    value: function () {
      var _waitForReadToComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.pendingRead) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.pendingRead;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function waitForReadToComplete() {
        return _waitForReadToComplete.apply(this, arguments);
      }

      return waitForReadToComplete;
    }()
    /**
     * Close wrapper
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.syncAndRelease();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "syncAndRelease",
    value: function () {
      var _syncAndRelease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.released = true;
                _context4.next = 3;
                return this.waitForReadToComplete();

              case 3:
                _context4.next = 5;
                return this.reader.releaseLock();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function syncAndRelease() {
        return _syncAndRelease.apply(this, arguments);
      }

      return syncAndRelease;
    }()
  }]);

  return ReadableWebToNodeStream;
}(readable_stream_1.Readable);

exports.ReadableWebToNodeStream = ReadableWebToNodeStream;